<template>
  <div>
    <div class="card-content pa-0" v-if="isNoReject">
      <b-field
        :type="typeSujet"
        :message="errorSujet">
        <template slot="label">
          <p class="is-size-7 has-text-grid-2">
            Sujet du message
            <span class="has-text-danger is-size-8 has-text-weight-normal">
              (Obligatoire)
            </span>
          </p>
        </template>
        <b-input v-model="sujet" type="text"></b-input>
      </b-field>
      <b-field
        :type="typeMess"
        :message="errorMess">
        <template slot="label">
          <p class="is-size-7 has-text-grid-2">
            Vos modifications
            <span class="has-text-danger is-size-8 has-text-weight-normal">
              (Obligatoire)
            </span>
          </p>
        </template>
        <b-input v-model="message" type="textarea"></b-input>
      </b-field>
      <div class="has-text-right">
        <b-button
          class="box-shadow-0 mr-20"
          rounded
          @click="$emit('close')">
          Annuler
        </b-button>
        <b-button
          class="box-shadow-0"
          type="is-primary"
          rounded
          icon-right="send"
          @click="envoyer">
          Envoyer
        </b-button>
      </div>
    </div>
    <div v-else>
      <div class="card-content pt-0">
        <figure class="image is-96x96 mx-auto">
          <img src="@/assets/images/icon_modal/icon_mail.png">
        </figure>
      </div>
      <div class="card-content pa-0 has-text-centered">
        <h4 class="has-text-weight-bold is-size-4">Demande envoyée</h4>
        <p class="is-size-14px">
          La proposition a bien été envoyée à <br>
          <strong class="has-text-primary">{{getCommercial.email}}</strong>
        </p>
        <div class="mt-20">
          <b-button
            class="box-shadow-0 mr-10"
            type="is-primary"
            rounded
            @click="$emit('close')">
            Fermer
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import { sendModifidationEmail } from '@/services/mail/sendEmail';
import gestionErreur from '@/services/general/gestionErreur';

const Recommandation = createNamespacedHelpers('recommandation');

export default {
  data: () => ({
    sujet: 'Je souhaite une modification sur la proposition',
    message: '',
    errorMess: '',
    typeMess: '',
    errorSujet: '',
    typeSujet: '',
    isNoReject: true,
  }),
  computed: {
    ...Recommandation.mapGetters({
      getCommercial: 'commercial',
      getClient: 'pdv',
      getRecom: 'recom',
    }),
  },
  methods: {
    verification() {
      if (!this.sujet) {
        this.typeSujet = 'is-danger'
        this.errorSujet = 'Champ obligatoire';
      }
      if (!this.message) {
        this.typeMess = 'is-danger'
        this.errorMess = 'Champ obligatoire';
      }
      setTimeout(function(scope) {
        scope.typeSujet = scope.typeMess = '';
        scope.errorSujet = scope.errorMess = '';
      }, 2000, this);
      return this.sujet && this.message;
    },
    async envoyer() {
      if (!this.verification()) return;
      const commercial = this.getCommercial.prenom ? `${this.getCommercial.prenom},<br>` : '';
      const email = this.getCommercial.email ? this.getCommercial.email : '';
      const loadingComponent = this.$buefy.loading.open({ container: null });
      try {
        await sendModifidationEmail(
          this.sujet, this.message, this.$route.params.id,
          commercial, this.getClient.libelle, '', this.getRecom.themeCampagne, email);
        loadingComponent.close();
        this.isNoReject = false;
      } catch (error) {
        loadingComponent.close();
        gestionErreur('Erreur serveur');
      }
    },
  },
};
</script>

<style>

</style>